import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ErdpouActions, ErdpouActionTypes} from '@references/ngrx/actions/erdpou.actions';
import {PaginationModel} from '@shared/models/pagination.model';
import {ConfigService} from '@config/config.service';
import {EdrpouClassifierModel} from '@services/back-office';
import {ErdpouClassifierSearchRequest} from '@shared/services/erdpou.service';

export const adapter: EntityAdapter<EdrpouClassifierModel> = createEntityAdapter<EdrpouClassifierModel>({});

export interface State extends EntityState<EdrpouClassifierModel> {
    loading: boolean,
    pagination: PaginationModel,
    filter: ErdpouClassifierSearchRequest,
}

export const initialState: State = adapter.getInitialState({
    loading: false,
    pagination: {
        first: true,
        last: false,
        number: 0,
        numberOfElements: 0,
        size: new ConfigService().paginationConfig.pageSize,
        totalElements: 0,
    },
    filter: {},
});

export function reducer(state = initialState, action: ErdpouActions): State {
    switch (action.type) {
        /** Load Erdpou */
        case ErdpouActionTypes.LoadErdpou:
            return {...state, loading: !action.payload?.dontShowLoading};

        case ErdpouActionTypes.LoadErdpouSuccess:
            return adapter.setAll(action.payload.content!, {
                ...state,
                loading: false,
                pagination: {
                    size: action.payload.size,
                    last: action.payload.last,
                    totalElements: action.payload.totalElements,
                    numberOfElements: action.payload.numberOfElements,
                    first: action.payload.first,
                    number: action.payload.number,
                },
            });

        case ErdpouActionTypes.LoadErdpouFailure:
            return {...state, loading: false};

        /** Change Page */
        case ErdpouActionTypes.ChangePage:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    number: action.payload.number,
                    size: action.payload.size,
                }
            };

        /** Set Initial Pagination */
        case ErdpouActionTypes.SetInitialPagination:
            return {...state, pagination: initialState.pagination};

        /** Set Filter */
        case ErdpouActionTypes.SetFilter:
            return {...state, filter: action.payload};

        /** Clear Filter */
        case ErdpouActionTypes.ClearFilter:
            return {...state, filter: initialState.filter};

        /** Set Initial State */
        case ErdpouActionTypes.SetInitialState:
            return {...initialState};

        default:
            return state;
    }
}

export const {
    selectIds: selectErdpouIds,
    selectEntities: selectErdpouEntities,
    selectAll: selectAllErdpou,
    selectTotal: selectErdpouTotal,
} = adapter.getSelectors();
